// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_OccypuingBlock_wrapper__1M38i"};